import { render, staticRenderFns } from "./AggregateData.vue?vue&type=template&id=1046db79"
import script from "./AggregateData.vue?vue&type=script&lang=js"
export * from "./AggregateData.vue?vue&type=script&lang=js"
import style0 from "./AggregateData.vue?vue&type=style&index=0&id=1046db79&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports